import React from "react";

const STYLES = {
  paid: "bg-green-100 text-green-700",
  open: "bg-orange-100 text-orange-700",
  overdue: "bg-red-100 text-red-700",
  uncollectible: "bg-red-100 text-red-700",
  draft: "bg-slate-100 text-slate-700",
  void: "bg-slate-100 text-slate-500",
  active: "bg-green-100 text-green-700",
  canceled: "bg-slate-100 text-slate-600",
  trialing: "bg-blue-100 text-blue-700",
  past_due: "bg-red-100 text-red-700",
  unpaid: "bg-red-100 text-red-700",
  shipped: "bg-blue-100 text-blue-700",
  delivered: "bg-green-100 text-green-700",
  in_transit: "bg-blue-100 text-blue-700",
  out_for_delivery: "bg-orange-100 text-orange-700",
  pre_transit: "bg-slate-100 text-slate-600",
  return_to_sender: "bg-red-100 text-red-700",
  failure: "bg-red-100 text-red-700",
  available_for_pickup: "bg-violet-100 text-violet-700",
  awaiting_shipment: "bg-amber-100 text-amber-800",
  awaiting_payment: "bg-orange-100 text-orange-700",
  on_hold: "bg-red-100 text-red-700",
  voided: "bg-slate-200 text-slate-600",
};

export default function StatusBadge({ status, testId }) {
  const cls = STYLES[status] || "bg-slate-100 text-slate-700";
  const label = (status || "—").replace(/_/g, " ");
  return (
    <span
      data-testid={testId || `status-${status}`}
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold capitalize ${cls}`}
    >
      {label}
    </span>
  );
}
